import apiClient from '../appConfig/interceptor';
import { endpoints } from '../utils/constants';

const getStates = () => apiClient.get(`${endpoints.pathPrefix}states`);
const getMetrics=(selectedProduct:string)=>apiClient.get(`${endpoints.pathPrefix}performance/metrics?product=${selectedProduct}`);
const getPerformanceInsights=(selectedProduct:string)=>apiClient.get(`${endpoints.pathPrefix}performance/insights?product=${selectedProduct}`);

const getPerformanceProblemWorkItems=(selectedProduct:string)=>apiClient.get(`${endpoints.pathPrefix}performance/problem-work-items?product=${selectedProduct}`);
const getPerformanceMetric=(metric:string,release_version:string,selectedProduct:string)=>apiClient.get(`${endpoints.pathPrefix}workItems/performanceMetrics?metric=${metric}&release_version=${release_version}&?product=${selectedProduct}`);

const metricApiList = {
    getStates,
    getMetrics,
    getPerformanceInsights,
    getPerformanceProblemWorkItems ,
    getPerformanceMetric 
};
export default metricApiList;
